// komodo serialises snowflake ids (PID, batch numbers) as JSON numbers above 2^53; JSON.parse would
// silently round them (…234624 → …234600) and a later PUT /{pid} then updates nothing while komodo
// still answers "success". Quote such integer literals before parsing so they survive as strings
// (Newtonsoft on the komodo side accepts quoted longs on the way back).
const MAX_SAFE = String(Number.MAX_SAFE_INTEGER); // 9007199254740991

const exceedsSafeInteger = (digits) =>
	digits.length > MAX_SAFE.length ||
	(digits.length === MAX_SAFE.length && digits > MAX_SAFE);

export const quoteBigInts = (text) => {
	if (typeof text !== 'string' || !/\d{16}/.test(text)) return text;
	let out = '';
	let i = 0;
	let inString = false;
	while (i < text.length) {
		const ch = text[i];
		if (inString) {
			if (ch === '\\') {
				out += ch + (text[i + 1] || '');
				i += 2;
			} else {
				if (ch === '"') inString = false;
				out += ch;
				i += 1;
			}
		} else if (ch === '"') {
			inString = true;
			out += ch;
			i += 1;
		} else if (ch === '-' || (ch >= '0' && ch <= '9')) {
			let j = i;
			if (text[j] === '-') j += 1;
			const start = j;
			while (j < text.length && text[j] >= '0' && text[j] <= '9') j += 1;
			const digits = text.slice(start, j);
			const next = text[j];
			const isInteger =
				digits.length > 0 && next !== '.' && next !== 'e' && next !== 'E';
			const literal = text.slice(i, j);
			out += isInteger && exceedsSafeInteger(digits) ? `"${literal}"` : literal;
			i = j;
		} else {
			out += ch;
			i += 1;
		}
	}
	return out;
};

/** axios transformResponse: JSON with big integers kept as strings; non-JSON bodies pass through. */
export const parseKomodoJson = (data) => {
	if (typeof data !== 'string') return data;
	try {
		return JSON.parse(quoteBigInts(data));
	} catch (e) {
		return data;
	}
};
